import React from 'react'
import Modal from '../../ui_reusable/Modal'
import { Button, Message } from 'rsuite'
import useStandardToaster from '../../ui_reusable/StandardToaster'
import { deleteModel } from '../../../api_operations/saveReportOrAndModel'

const DeleteModel = ({ model, setRefresh, open, onClose }) => {
  const { pushToast } = useStandardToaster()

  const handleSubmit = async () => {
    try {
      const success = await deleteModel(model, pushToast)

      if (success) {
        setRefresh(new Date().getTime())
        onClose()
      }
    } catch (error) {
      console.error(error)
      pushToast(
        <Message type="error">
          {error.message || 'Failed to delete model'}
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={`Delete ${model.name}`}>
      <Modal.Body>
        <p>
          Are you sure you want to delete this model? This action cannot be
          undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="submit"
          onClick={handleSubmit}
          appearance="primary"
          color="red"
        >
          Delete
        </Button>
        <Button type="submit" onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteModel
